import { render, staticRenderFns } from "./CompProfilePetsInformationCard.vue?vue&type=template&id=5eb1ba2c&scoped=true"
import script from "./CompProfilePetsInformationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompProfilePetsInformationCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb1ba2c",
  null
  
)

export default component.exports